/**
 * Один шаблон дважды — отказ, а не молчаливое схлопывание.
 *
 * Два клипа одного шаблона — это два похожих ролика за две цены, и заказать
 * их случайно (лишним кликом в панели) не должно быть возможно.
 *
 * Файл когда-то держал `planSet` — планировщик набора роликов ГЕРОИНИ:
 * что завести, что оставить, что удалить, когда владелец меняет состав
 * набора. Наборов героинь больше нет (цель настройки — характер, а состав
 * роликов ведёт файл сценария), и планировать стало нечего. Ошибка
 * пережила его: дубль шаблона отбивают обе оставшиеся цели.
 */
export class DuplicateTemplateError extends Error {
  constructor(readonly presetId: string) {
    super(`шаблон «${presetId}» указан в наборе дважды`)
    this.name = 'DuplicateTemplateError'
  }
}

/**
 * Сколько роликов может быть у одного уровня.
 *
 * Пять — решение владельца: столько роликов он готов показывать за один
 * проход сцены. Число живёт здесь, а не в `game_configs` (правило №3),
 * потому что это не настройка экономики, а граница формы контента: длину
 * прохода обещает индикатор «клип N из M», её же считает сид при проверке
 * графа, и меняться на живой игре она не должна.
 *
 * Нижняя граница — один: уровень без роликов игроку не показывается вовсе,
 * и «сохранить пустой набор» означало бы спрятать сцену кнопкой, у которой
 * написано «выбрать шаблоны».
 */
export const MAX_CLIPS_PER_LEVEL = 5
